import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import {
  GroupedImagesResponse,
  ImageAttributes,
} from "../../Interfaces/IBubbleImagesResponse";
import { fetchImagesCarouselFromOneBubble } from "../../Services/BubbleService";
import ZoomableFullscreen from "./ZoomableFullscreen";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Carousel.css";

interface CarouselProps {
  Id?: number | null;
}

const Carousel: React.FC<CarouselProps> = ({ Id }) => {
  const [imageGroup, setImageGroup] = useState<GroupedImagesResponse | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [fullscreenImage, setFullscreenImage] =
    useState<ImageAttributes | null>(null);

  const openFullscreen = (image: ImageAttributes) => {
    setFullscreenImage(image);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  useEffect(() => {
    const getImages = async () => {
      try {
        if (!Id) {
          console.error("Aucun ID fourni");
          return;
        }
        setLoading(true);
        const data = await fetchImagesCarouselFromOneBubble(Id);
        setImageGroup(data);
      } catch (err) {
        setError("Failed to load images");
      } finally {
        setLoading(false);
      }
    };

    getImages();
  }, [Id]);

  if (loading) return <div>Loading...</div>;
  if (!imageGroup || imageGroup.data.attributes.images.data.length === 0)
    return <p>Aucun groupe d'images trouvé</p>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        {imageGroup.data.attributes.images.data.map((image) => (
          <SwiperSlide key={image.id} onClick={() => openFullscreen(image)}>
            <img
              key={image.id}
              src={image.attributes.url}
              alt={image.attributes.alternativeText || "Image"}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {fullscreenImage && (
        <ZoomableFullscreen image={fullscreenImage} onClose={closeFullscreen} />
      )}
    </>
  );
};

export default Carousel;
